import { CLASS_NAMES } from '../../utils/constants'
import Destroyable from './Destroyable'

export default class Moveable extends Destroyable {
  move({ x, y }) {
    super.setPosition({ x, y})
    // this.isMoving = false
  }
}

Moveable.className = CLASS_NAMES.MOVEABLE
